module.exports = __webpack_public_path__ + "assets/pdf/vino-tinto.a5dbf0b7.pdf";